import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const token = authService.token || localStorage.getItem('jwt_token');

  // Prepare headers object
  const headers: { [key: string]: string } = {
    'Content-Type': 'application/json',
  };

  // Add session headers if available
  if (authService.sessionUUID) {
    headers['session_uuid'] = authService.sessionUUID;
  }

  if (authService.userId) {
    headers['user_id'] = authService.userId;
  }

  // Add authorization token if available
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Clone request with headers
  const authReq = req.clone({
    setHeaders: headers,
  });

  return next(authReq);
};
